/**
 * Checks if the mismatch loss between the left and right ear is greater than the threshold
 *
 * @param deviceModelId Input model id for the hearing device
 * @param audiograms Input binaural audiograms for the hearing device
 * @returns Returns whether there is a mismatch loss between the left and right ear
 */
export function mismatchLossCheck(deviceModelId, audiograms) {
    var mismatchLossThreshold = 15;
    switch (deviceModelId) {
        case "6144007":
        case "540938247":
        case "72780372515670":
        case "72986808818502":
            mismatchLossThreshold = 15;
            break;
    }
    var audiogramLeft = audiograms["Left"];
    var audiogramRight = audiograms["Right"];
    var sumLeft = 0;
    var sumRight = 0;
    // only the 3 lowest frequencies are tested
    for (var i = 0; i < 3; i++) {
        sumLeft += audiogramLeft[i];
        sumRight += audiogramRight[i];
    }
    var avgLeft = sumLeft / 3;
    var avgRight = sumRight / 3;
    return Math.abs(avgLeft - avgRight) > mismatchLossThreshold;
}
